import { render, staticRenderFns } from "./boy.vue?vue&type=template&id=9c39b04a&scoped=true&"
import script from "./boy.vue?vue&type=script&lang=js&"
export * from "./boy.vue?vue&type=script&lang=js&"
import style0 from "./boy.vue?vue&type=style&index=0&id=9c39b04a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c39b04a",
  null
  
)

export default component.exports